import { axiosPublic } from "@app/dashboard/tools/axios/axiosInstance";

type TUserName = 'email' | 'phone';

export const userActivationDataSubmit = (
  {
    token,
    userNameType,
    fullName,
    email,
    phone,
    password
  }: {
    token: string,
    userNameType: TUserName,
    fullName: string,
    email: string,
    phone?: string,
    password: string
  }
) => {

  const reqBody = {
    token,
    user_name_field: userNameType,
    full_name: fullName,
    email,
    ...(phone ? { phone_number: phone } : {}),
    password
  };

  return axiosPublic.post(`/dashboard/api/v1/new_account/activate_staff_v3`, reqBody);
};

export const userActivationVerifyOtp = (
  {
    token,
    userNameType,
    fullName,
    email,
    phone,
    password,
    otp
  }: {
    token: string,
    userNameType: TUserName,
    fullName: string,
    email: string,
    phone?: string,
    password: string,
    otp: string
  }
) => {

  const reqBody = {
    token,
    user_name_field: userNameType,
    full_name: fullName,
    email,
    ...(phone ? { phone_number: phone } : {}),
    password,
    otp
  };

  return axiosPublic.post(`/dashboard/api/v1/new_account/verify_otp_v3`, reqBody);
};

export const userActivationResendOtp = (
  {
    token,
    userNameType,
    email,
    phone,
  }: {
    token: string,
    userNameType: TUserName,
    email: string,
    phone?: string,
  }
) => {

  const reqBody = {
    token,
    user_name_field: userNameType,
    email,
    ...(phone ? { phone_number: phone } : {}),
  };

  return axiosPublic.post(`/dashboard/api/v1/new_account/resend_otp_v3`, reqBody);
};

export const getInvitationLinkStatus = (token: string) => {
  const params = { token };

  return axiosPublic.post(`/dashboard/api/v1/new_account/validate_invitation`, params);
};